import {
  FieldValues,
  RegisterOptions,
  UseFormRegister,
  useFormContext,
} from "react-hook-form";

interface ITextInputProps {
  containerClass?: string;
  label?: string;
  icon?: React.ReactNode;
  registerOptions?: RegisterOptions<FieldValues, string>;
  name: string;
  className?: string;
  placeholder?: string;
  type?: string;
  disabled?: boolean;
  min?: string;
  max?: string;
}

function TextInputUnstyled({
  containerClass,
  label,
  icon,
  registerOptions,
  name,
  className,
  placeholder = "Enter value...",
  disabled,
  type = "text",
  min,
  max,
}: ITextInputProps) {
  const {
    register,
    formState: { errors },
  }: { register: UseFormRegister<FieldValues>; formState: { errors: any } } =
    useFormContext();

  let errorMessage = String(errors[name]?.message || "");

  if (String(name).includes(".")) {
    const [parent, index, child] = String(name).split(".");
    errorMessage = String(errors?.[parent]?.[index]?.[child]?.message || "");
  }

  return (
    <div className={`flex flex-col w-full ${containerClass}`}>
      {label && (
        <label className="text-xs text-left text-body font-semibold pl-1">
          {label}
        </label>
      )}
      <section className="w-full relative">
        <input
          type={type}
          placeholder={placeholder}
          disabled={disabled}
          {...register(name, registerOptions)}
          autoComplete="off"
          data-error={errorMessage ? true : false}
          className={`h-10 w-full text-sm text-body font-semibold placeholder:font-medium px-2 py-1 outline-none z-10 rounded-lg 
              disabled:cursor-not-allowed disabled:bg-gray/30 data-[error=true]:placeholder:text-error/60 ${className}`}
          min={min}
          max={max}
        />

        <span
          data-error={errorMessage ? true : false}
          className="text-darkGray/80 data-[error=true]:text-error absolute w-5 right-4 top-1/2 -translate-y-1/2"
        >
          {icon}
        </span>
        {type === "date" && errorMessage && (
          <p className="text-xs text-error/90 font-medium pl-1 ">
            {errorMessage}
          </p>
        )}
      </section>
    </div>
  );
}

export default TextInputUnstyled;
